import { useEffect } from 'react';

const Lightbox = ({ src, alt = '', onClose }) => {
  // close on ESC
  useEffect(() => {
    const onKey = (e) => e.key === 'Escape' && onClose?.();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-[100] bg-black/80 backdrop-blur-sm flex items-center justify-center p-4"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
    >
      <img
        src={src}
        alt={alt}
        className="max-w-[95vw] max-h-[90vh] rounded-xl shadow-2xl"
        onClick={(e) => e.stopPropagation()} // prevent close when clicking image
      />
      {/* Close button */}
      <button
        onClick={onClose}
        className="absolute top-4 right-4 text-white/90 text-2xl leading-none"
        aria-label="Close"
        title="Close"
      >
        ✕
      </button>
    </div>
  );
};

export default Lightbox;
